import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function formatShortTicket(ticket?: string | number | null): string {
  if (!ticket) return ''
  const str = String(ticket)
  // Si parece un UUID o hash largo, cortamos
  if (str.length > 20 && str.includes('-')) {
    return str.split('-')[2].toUpperCase()
  }
  return str.toUpperCase()
}

export async function copyToClipboard(text: string): Promise<boolean> {
  if (navigator.clipboard && window.isSecureContext) {
    try {
      await navigator.clipboard.writeText(text)
      return true
    } catch (err) {
      console.error('Failed to copy to clipboard', err)
    }
  }
  
  // Fallback for non-secure contexts (HTTP)
  const textArea = document.createElement("textarea")
  textArea.value = text
  
  // Evitar scroll
  textArea.style.top = "0"
  textArea.style.left = "0"
  textArea.style.position = "fixed"
  
  document.body.appendChild(textArea)
  textArea.focus()
  textArea.select()
  
  try {
    const successful = document.execCommand('copy')
    document.body.removeChild(textArea)
    return successful
  } catch (err) {
    console.error('Fallback: Oops, unable to copy', err)
    document.body.removeChild(textArea)
    return false
  }
}

